import React from "react";

function BookIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 19 18"
    >
      <path
        fill="currentColor"
        d="M5.382 16.5h11.25V15H5.39c-.347-.009-.76-.146-.76-.75s.413-.741.76-.75h11.24V3c0-.827-.672-1.5-1.5-1.5h-9.75c-.904 0-2.25.6-2.25 2.25v10.5c0 1.65 1.346 2.25 2.25 2.25zM4.632 6V3.75c0-.604.412-.741.75-.75h9.75v9h-10.5V6z"
      ></path>
      <path fill="currentColor" d="M6.882 4.5h6.75V6h-6.75V4.5z"></path>
    </svg>
  );
}

export default BookIcon;
